/* BYON · Colección: "Ver más preguntas" de la FAQ única y medición de la tarjeta "Guía rápida"
 * Ronda 11 (25-sep-2026) · Bloque D2 · SEO-3 A. Solo se carga con el interruptor aprende_elegir encendido.
 * - FAQ: las filas sobre el máximo llevan data-byon-faq-extra y quedan en el HTML; sin JS se ven todas.
 * - Tarjeta: byonTrack('guide_tile_click', {collection, destination}) (K1). El ancla #byon-guia la abre
 *   assets/byon-collection.js (expandSeo), igual que "Leer guía completa".
 * - "Aprende a elegir" se mide con data-byon-promo (select_promotion, listener de Base en byon-global.js).
 */
(function () {
  if (window.__byonColGuide) return;
  window.__byonColGuide = true;
  var doc = document;

  function track(name, data) {
    (window.byonTrack || function () {})(name, data);
  }

  function setFaq(button, open) {
    var list = doc.getElementById(button.getAttribute('aria-controls'));
    if (!list) return;
    list.classList.toggle('is-expanded', open);
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    var more = button.querySelector('[data-more-label]');
    var less = button.querySelector('[data-less-label]');
    if (more) more.hidden = open;
    if (less) less.hidden = !open;
    if (open) {
      var first = list.querySelector('[data-byon-faq-extra] > summary');
      if (first) first.focus({ preventScroll: true });
    }
  }

  doc.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var more = target.closest('[data-byon-faq-more]');
    if (more) {
      event.preventDefault();
      setFaq(more, more.getAttribute('aria-expanded') !== 'true');
      return;
    }

    var tile = target.closest('[data-byon-tile-link]');
    if (tile) {
      track('guide_tile_click', {
        collection: tile.getAttribute('data-byon-collection') || '',
        destination: tile.getAttribute('data-byon-dest') === 'article' ? tile.getAttribute('href') || '' : 'guia_coleccion',
      });
    }
  });
})();
